<template>
  <div>
    <p v-if="departure.insurance.msg">
      {{ departure.insurance.msg }}
    </p>
    <p v-if="departure.insurance.old">
      <span class="mr-3">Seguro medico para mayores de {{ departure.insurance.age }}</span>
      <strong>{{ departure.currency }}{{ departure.insurance.old }}</strong>
    </p>
    <p v-if="departure.insurance.outland">
      <span class="mr-3">Seguro medico para viaje al exterior</span> <strong>{{ departure.currency }}{{ departure.insurance.outland }}</strong>
    </p>
  </div>
</template>

<script>
export default {
  props: ['departure']
}
</script>
